export default {
  model: {
    event: 'input',
    prop: 'value'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lazyValue: this.value,
      rng: 0
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      },
    },
    showError () {
      return this.$attrs['error-messages'].length > 0
    },
    elementId () {
      const labelToId = this.label.toLowerCase().replace(/\s/g, '')
      return `gg_tf_${labelToId}${this.rng}`
    },
  },
  watch: {
    value (val) {
      this.internalValue = val
    }
  },
  beforeMount () {
    this.rng = Math.floor(Math.random() * 100)
  }
}
